"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../../core/theme");
exports.default = {
    progressPlayed: {
        backgroundColor: function (data) { return data.progressColor; },
    },
    progressSeekTo: {
        backgroundColor: function (data) {
            return (0, theme_1.transperentizeColor)(data.progressColor, 0.5);
        },
    },
    progressSeekBtn: {
        backgroundColor: function (data) { return data.progressColor; },
    },
};
//# sourceMappingURL=progress.theme.js.map